import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const usage: IMcAppType = {
  name: "usage_SAP",
  path: "/my-account/usage/:view?",
  description: "Usage information",
  title: "Usage",
  parameters: {
    properties: {
      caid: CommonParameters.caid,
      view: { description: "View of usage data", type: "string" },
    },
  },
  navFlow: NavFlow.TAB,
  parent: Tab.USAGE,
  conditions: {
    intent: "usage",
    customerType: CustomerType.sap,
  },
};

export const usage_KRAKEN: IMcAppType = {
  name: "usage_KRAKEN",
  path: "/my",
  description: "Directing to RX dashboard due to no generic usage page",
  title: "Usage",
  navFlow: NavFlow.TAB,
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "usage",
    customerType: CustomerType.kraken,
  },
  ignorePathMapping: true,
};
